module.exports = __webpack_public_path__ + "img/NAKED,INC._Logotype_b.e8ee6c71.png";